import { CepData, PassengerCounts } from '@flysas-tech/book-value-stream-models';
import { Object, String, Array, Optional, Static } from '@sinclair/typebox';

export type PartnerAwardCreateCartBody = Static<typeof PartnerAwardCreateCartBody>;
export const PartnerAwardCreateCartBody = Object({
  cepData: CepData,
  savedTravelerIds: Optional(Array(String())),
});

export type PartnerAwardAddJourneysToCartPayload = Static<typeof PartnerAwardAddJourneysToCartPayload>;
export const PartnerAwardAddJourneysToCartPayload = Object({
  cartId: String(),
  offerId: String(),
  outboundProductId: String(),
  inboundProductId: Optional(String()),
  passengerCounts: PassengerCounts,
  selectedCouponCodes: Array(String()),
});
